import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
    CardMedia,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import handbooksService from "../../../services/handbooks.service";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import imgHandBooks from "../../../assets/images/news/img-manual-book.svg";
import background from "../../../assets/images/news/background.svg";
import PlayVideo from "../../../assets/images/icon_play.svg";
import HoverPlayVideo from "../../../assets/images/icon_hover_play.svg";
import cssVariables from "../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";
import { LowPriority } from '@mui/icons-material';
import { height, maxWidth } from '@mui/system';
import * as Util from "../../../services/global.service";

const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    paperContainer: {
        backgroundImage: `url(${background})`,
        width: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },
};
const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"
    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
    },
    processBgClickPlay: {
        border: " 2px solid #5DA196 !important",
        color: "#5DA196",
        "& > p > .MuiBox-root": {
            backgroundImage: `url(${PlayVideo})`,
            width: "22.5px",
            height: "22.5px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "relative",
        },
        "&:hover": {
            backgroundColor: "#5DA196 !important",
            color: "#FFFFFF",
            "& > p > .MuiBox-root": {
                backgroundImage: `url(${HoverPlayVideo})`,
            }
        },
    },
    processBgCompetency: {
        background: "#958CCB !important",
    },

})
const ContentBook = () => {
    const { t } = useTranslation()
    let { serial } = useParams();
    const handbookData =
    {
        serial: "85b963a8-ee22-4ba3-af28-9824713c319e",
        title: "การวางแผนบันทึกข้อตกลง (Planning)",
        excerpt: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
        description: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
        video_type: "youtube",
        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
        video_url: "https://www.youtube.com/embed/30Y9kBijqS0",
        created_at: "2020-05-20T09:56:00.000Z",
    }
    const [dataContentHandbook, setContentHandbook] = React.useState({});
    const getContentHandbook = () => {
        handbooksService.content(serial).then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {
                    setContentHandbook(response.data)
                }


            },
        );
    }
    useEffect(() => {
        if (dataContentHandbook !== undefined && dataContentHandbook !== null && dataContentHandbook !== "null") {
            getContentHandbook();
        }
    }, []);
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    width: '100%'
                }}
            >
                <Box style={styles.paperContainer}>
                    <Grid container pt={2} pb={2} sx={{ paddingLeft: '20px', paddingTop: '20px' }}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("handbook.label.homePage")}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/manual/listbooks')}>{t("handbook.label.userManualPage")}</span> /  <span style={styles.end}> {t("handbook.label.contentPage")}</span> </Typography>
                    </Grid>
                    <Grid lg md xs={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <Grid lg md xs={4} display='flex' justifyContent='center'>
                            <img src={imgHandBooks} style={{ maxWidth: '470px', maxHeight: '470px' }}></img>
                        </Grid>
                        <Grid lg md xs={8} display='flex' justifyContent='center' flexDirection='column'>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography fontSize={64} lineHeight="70px" fontWeight={600} color="#404349"  >
                                    {t("handbook.label.handbooks")}
                                </Typography>
                                <Typography fontSize={24} lineHeight="32px" fontWeight={700} color="#404349" sx={{ paddingTop: "10px", textAlign: 'center' }}>
                                    {t("handbook.label.content")}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {dataContentHandbook !== undefined && dataContentHandbook !== null && dataContentHandbook !== "null" ?
                    <Box sx={{ padding: '70px' }}>
                        <Typography fontSize={36} lineHeight="39.5px" color="#404349" fontWeight={600} sx={{ paddingTop: "30px" }} >
                            {formatData(dataContentHandbook?.content?.title, "-")}
                        </Typography>
                        <Box sx={{ display: "flex", flexFlow: "row", width: '100%', paddingTop: "20px" }}>
                            <Typography fontSize={18} lineHeight="21px" fontWeight={400} color="#949494" sx={{ paddingLeft: "10px" }}>
                                {t("handbook.label.date")}: {Util.dateDayFormat(dataContentHandbook?.content?.created_at, "-")}
                            </Typography>
                        </Box>
                        <Box sx={{ paddingTop: '27px', height: "720px" }}>
                            {/* <iframe style={{ width: "100%", height: "100%", maxHeight: "720px" }} src={dataContentHandbook?.content?.video_url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                            </iframe> */}
                            {dataContentHandbook?.content?.video_type === 'url' &&
                                <CardMedia
                                    style={{ maxWidth: '100%', maxHeight: 720 }}
                                    component='video'
                                    image={dataContentHandbook?.content?.video_url}
                                    controls
                                />
                            }

                        </Box>
                        <Typography fontSize={18} lineHeight="29.5px" color="#404349" fontWeight={300} sx={{ paddingTop: "30px" }} dangerouslySetInnerHTML={{ __html: formatData(dataContentHandbook?.content?.description, "-") }}>
                        </Typography>
                    </Box>
                    : null}
            </Box>
        </>
    )
};
export default ContentBook;